var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7575 14.2614C24.6669 15.3241 23.8269 16.1597 22.7789 16.2272C20.7912 16.3549 17.2955 16.5294 13.0267 16.5294C8.76213 16.5294 5.26913 16.3553 3.28038 16.2275C2.23624 16.1604 1.39715 15.3309 1.30275 14.2724C1.1658 12.7376 1 10.5237 1 8.80207C1 7.07124 1.16763 4.81655 1.305 3.25959C1.39844 2.2 2.23774 1.36891 3.28284 1.30179C5.27202 1.17408 8.76396 1 13.0267 1C17.2935 1 20.788 1.17441 22.7762 1.30212C23.8239 1.36956 24.665 2.20467 24.7548 3.26719C24.8711 4.64388 25 6.65488 25 8.80207C25 10.932 24.8731 12.9057 24.7575 14.2614H24.7575Z",
    stroke: "#193232",
    strokeWidth: 1.125,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4882 8.02334C19.2252 8.02334 17.3906 6.18882 17.3906 3.92578",
    stroke: "#193232",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4859 10.3648C17.9297 10.3648 15.0469 7.48204 15.0469 3.92578",
    stroke: "#193232",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4875 12.7063C16.6381 12.7063 12.707 8.77504 12.707 3.92578",
    stroke: "#193232",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizz);
export default __webpack_public_path__ + "static/media/bizz.c3281fc9aca5a7801800fcb17e5a2ca2.svg";
export { ForwardRef as ReactComponent };